import type { Sticker } from '../types';

export const spring: Sticker[] = [
  {
    id: 27001,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/001-sun.png',
    name: 'Słońce',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27002,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/002-kite.png',
    name: 'Latawiec',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27003,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/003-spring.png',
    name: 'Wiosna',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27004,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/004-tree.png',
    name: 'Drzewo',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27005,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/005-butterfly.png',
    name: 'Motyl',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27006,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/006-reeds.png',
    name: 'Trzciny',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27007,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/007-farming.png',
    name: 'Rolnictwo',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27008,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/008-bbq.png',
    name: 'Grill',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27009,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/009-flowers.png',
    name: 'Kwiaty',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27010,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/010-strawberry.png',
    name: 'Truskawka',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27011,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/011-flower.png',
    name: 'Kwiat',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27012,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/012-basket.png',
    name: 'Koszyk',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27013,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/013-paper boat.png',
    name: 'Papierowa Łódka',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27014,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/014-mushroom.png',
    name: 'Grzyb',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27015,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/015-calendar.png',
    name: 'Kalendarz',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27016,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/016-sprout.png',
    name: 'Kiełek',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27017,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/017-badminton.png',
    name: 'Badminton',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27018,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/018-umbrella.png',
    name: 'Parasol',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27019,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/019-pinwheel.png',
    name: 'Wiatraczek',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 27020,
    url: 'https://stickers.nauczniaczek.pl/colections/14881776-spring/png/020-birdhouse.png',
    name: 'Budka dla Ptaków',
    category: 'spring',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];